import * as actions from '../../actions/actions'

const initialState = {
  users: null,
  error: null
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_USER_SUCCESS:
      return fetchUserSuccess(state, action)
    case actions.FETCH_USER_FAILURE:
      return fetchUserFailure(state, action)
    case actions.ENABLE_USER_SUCCESS:
      return enableUserSuccess(state, action)
    case actions.ENABLE_USER_FAILURE:
      return enableUserFailure(state, action)
    case actions.DISABLE_USER_SUCCESS:
      return disableUserSuccess(state, action)
    case actions.DISABLE_USER_FAILURE:
      return disableUserFailure(state, action)
    case actions.RESET_USER_SUCCESS:
      return resetUserSuccess(state, action)
    case actions.RESET_USER_FAILURE:
      return resetUserFailure(state, action)
    case actions.DELETE_USER_SUCCESS:
      return deleteUserSuccess(state, action)
    case actions.DELETE_USER_FAILURE:
      return deleteUserFailure(state, action)
    default:
      return state
  }
}

const enableUserSuccess = (state, action) => {
  return {
    ...state,
    users: action.users
  }
}

const enableUserFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const disableUserSuccess = (state, action) => {
  return {
    ...state,
    users: action.users
  }
}

const disableUserFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const resetUserSuccess = (state, action) => {
  return {
    ...state,
    users: action.users
  }
}

const resetUserFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const fetchUserSuccess = (state, action) => {
  return {
    ...state,
    users: action.users
  }
}

const fetchUserFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const deleteUserSuccess = (state, action) => {
  return {
    ...state,
    users: action.users
  }
}

const deleteUserFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}